export const managerMisc = {
  // Shared field / label strings reused across the advisor and user views
  fields: {
    name: "Nombre",
    lastname: "Apellidos",
    email: "Correo electrónico",
    idNumber: "Cédula",
    phone: "Teléfono",
  },
  // src/views/Manager/pagos/index.vue
  pagos: {
    title: "Facturas de pago",
    subtitle: "Listado de pagos realizados por los usuarios",
    emailUser: "Email user",
    value: "Valor",
    issueDate: "Fecha de emisión",
    status: "Estado",
    downloadInvoice: "Descargar Factura",
    generatingInvoice: "Generando Factura ...",
    almostDone: "Casi termina por favor espere ...",
    loading: "Cargando ...",
    invoiceError: "Disculpe la factura no se pudo generar",
  },
  // src/views/Manager/advisors/* and src/components/manager/advisors/*
  advisors: {
    title: "Asesores de la plataforma",
    subtitle: "Listado de asesores.",
    createNew: "Crear nuevo",
    thId: "ID",
    thRefCode: "Código Ref.",
    thEmail: "Email",
    thRegisterDate: "Fecha de registro",
    deleteConfirmMsg: "¿Estas seguro de eliminar el asesor?",
    deleteConfirmHeader: "Confirmar",
    menuUpdateInfo: "Actualizar información",
    menuAffiliatesList: "Lista de afiliados",
    menuDelete: "Eliminar",
    createTitle: "Crear nuevo asesor",
    savingInfo: "Guardando información...",
    saveAdvisor: "Guardar asesor",
    updateTitle: "Actualizar los datos del asesor",
    updatingInfo: "Actualizando información...",
    updateAdvisor: "Actualizar asesor",
    cancel: "Cancelar",
  },
  // src/components/manager/advisors/modalListAffiliates.vue
  affiliates: {
    listTitle: "Listado de afiliados",
    emptyPre: "No tiene usuarios afiliados a su código",
  },
  // src/components/manager/users/menuRoutes.vue
  menu: {
    checkinsDone: "Checkin realizados",
    checkinsPending: "Checkin pendientes",
    checkinsScheduled: "Checkin programados",
    logoAndName: "Logo y nombre del alojamiento",
    welcomeMessage: "Mensaje de bienvenida",
    policies: "Políticas del alojamiento",
    roomKeys: "Clave de habitaciones",
    authorities: "Autoridades",
    guestReviews: "Valoraciones de huéspedes",
  },
  // src/components/manager/users/accommodations.vue
  accommodations: {
    createdDate: "Fecha de creación",
    checkins: "Check-ins",
  },
  // src/views/Manager/index.vue
  dashboard: {
    title: "Panel administrativo",
    subtitle: "Listado de estadísticas de la plataforma",
    registeredUsers: "Usuarios registrados",
    viewList: "Ver listado",
    propertiesCreated: "Propiedades creadas",
    checkinsDone: "Checkin Realizados",
  },
};
